export class NewUserCentricMesssages {
    public static OnResettingAllFieldsDataSuccess:string ="All fields are reset successfully";
    public static OnUploadingResumeFileSuccess:string ="Resume uploaded successfully";
    public static OnSavingSavedSearchAlreadyExistsError:string ="Your search already exists in list";
    public static OnSavingSavedSearchFilledBySectionError:string ="Your search must be filled by any section";
    public static OnSavingSavedSearchLoginError:string ="Please login to your account or contact Apply4U";
    
}